
export default {
  CLOSE: "Close"
};
